// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: 'AIzaSyAK0iGmlCPiGxwSKHk3AwroF2CgmeM9HhA',
    authDomain: 'api-astrade.firebaseapp.com',
    databaseURL: 'https://api-astrade.firebaseio.com',
    projectId: 'api-astrade',
    storageBucket: 'api-astrade.appspot.com',
    messagingSenderId: '938993269454',
    appId: '1:938993269454:web:609002959886e9bdc1ee9f',
    measurementId: 'G-39HB17XE32'
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
